import { ConditionKeyRequest } from "./types/request"

/**
 * Map containing project specific key/value pairs resp. entries specifying the needed
 * conditions.
 */
export class ConditionKey {
    private _characteristics: { [key: string]: string }

    constructor(pairs: { [key: string]: string }) {
        this._characteristics = Object.assign({}, pairs)
    }

    /**
     * Add a new characteristic to the condition key.
     * @param {String} key the characteristic key
     * @param {String} value the characteristic value
     */
    characteristic(key: string, value: string): this {
        this._characteristics[key] = value
        return this
    }

    build(): ConditionKeyRequest {
        return { characteristics: this._characteristics }
    }
}

/**
 * Element specifying which characteristics and characteristic values the response should contain.
 */
export class ConditionKeys {
    private _conditions: ConditionKey[]

    constructor(array: ConditionKey[]) {
        this._conditions = array || []
    }

    /**
     * Append a condition key.
     * @param {ConditionKey} ck the condition key
     * @return this
     */
    add(ck: ConditionKey): this {
        this._conditions.push(ck)
        return this
    }

    build(): ConditionKeyRequest[] | null {
        if (this._conditions.length === 0) {
            return null
        }
        return this._conditions.map((condition) => condition.build())
    }
}
